import { Injectable } from '@angular/core';
import { Synchronization } from '../../entities/synchronization';
import { localDb } from '../local-db.service';
import { BaseRepository } from './base.repository';

@Injectable({ providedIn: 'root' })
export class SynchronizationRepository extends BaseRepository<Synchronization, string> {
  private static readonly summaryItemType = '__sync_summary__';

  constructor() {
    super(localDb.synchronizations, 'itemType');
  }

  async getByItemType(itemType: string): Promise<Synchronization | undefined> {
    return this.getById(itemType);
  }

  async getLastSyncAt(): Promise<string | undefined> {
    const summary = await this.getByItemType(SynchronizationRepository.summaryItemType);
    if (summary?.lastExecution) {
      return summary.lastExecution;
    }

    const rows = await this.getAll();
    if (rows.length === 0) {
      return undefined;
    }

  return rows
    .map(row => row.lastExecution)
    .filter(Boolean)
    .sort((a, b) => a.localeCompare(b))
    .at(-1);
  }

  async saveStepResult(
    itemType: string,
    itemsCount: number,
    itemsUpdated = itemsCount,
    itemsRemoved = 0
  ): Promise<void> {
    await this.upsert(
      new Synchronization({
        itemType,
        itemsCount,
        itemsUpdated,
        itemsRemoved,
        lastExecution: new Date().toISOString(),
      })
    );
  }

  async saveSummary(lastExecution = new Date().toISOString()): Promise<void> {
    await this.upsert(
      new Synchronization({
        itemType: SynchronizationRepository.summaryItemType,
        itemsCount: 0,
        itemsUpdated: 0,
        itemsRemoved: 0,
        lastExecution,
      })
    );
  }
}
